import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import {fetchAIAssistants} from '../actions/aiassistant'
import AIAssistant from '../components/AIAssistant'

const mapStateToProps = state => {
  const { aiassistant } = state

  const {
    isFetching,
    messages
  } = aiassistant || {
    isFetching: true,
    messages: []
  }
  return {
    isFetching,
    messages,
    state
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAIAssistants: fetchAIAssistants,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(AIAssistant)
